export enum LanguageEnum {
  English = 'en',
  French = 'fr',
  Polish = 'pl',
  Armenian = 'am',
  Portugal = 'pr',
  Spanish = 'es',
  Arabic = 'ar'
}

export const TextDirection = {
  Ltr: 'ltr',
  Rtl: 'rtl'
} as const;

export type TextDirectionType = typeof TextDirection[keyof typeof TextDirection];

export interface LanguageModel {
  _id: string;
  code: string;
  icon: string;
  name: string;
  isEnabled: boolean;
  orgId: string;
  __v: number;
}
